import {makeStyles} from "@material-ui/core/styles"

export const useStyles = makeStyles((theme) => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  sectionIcon: {
    fontSize: 36,
    color: theme.palette.primary.main,
    marginTop: 2,
  },
  startButton: {
    backgroundColor: '#4caf50',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  chipFinished: {
    border: '2px solid #4caf50',
    color: '#4caf50',
    backgroundColor: 'transparent',
    fontWeight: 'bold',
  },
  chipNotFinished: {
    border: '2px solid #f44336',
    color: '#f44336',
    backgroundColor: 'transparent',
    fontWeight: 'bold',
  },
  statCard: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    gap: theme.spacing(2),
  },
  statTitle: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  statValue: {
    fontWeight: 'bold',
    fontSize: '2rem',
    lineHeight: 1.2,
  },
  statLabel: {
    color: theme.palette.text.secondary,
  },
  viewDetails: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: '#4caf50',
    cursor: 'pointer',
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  viewDetailsDisabled: {
    color: theme.palette.text.disabled,
    cursor: 'not-allowed',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  allResultsBtn: {
    borderColor: '#4caf50',
    color: '#4caf50',
    fontWeight: 'bold',
    '&:hover': {
      borderColor: '#388e3c',
      backgroundColor: 'rgba(76, 175, 80, 0.08)',
    },
  },
}))
